import { PlatformGroupRoleDto } from "./PlatformGroupRoleDto";
import { TenantDto } from "./TenantDto";

export class User {
    id!: string;
    userName!: string;
    email!: string;
    emailConfirmed!: boolean;
    phoneNumber!: string;
    phoneNumberConfirmed!: boolean;
    lockoutEnabled!: boolean;
    twoFactorEnabled!: boolean;
    accessFailedCount!: number;
    lockoutEnd!: Date;   
}

export class UsersDto {
    pageSize!: number;
    totalCount!: number;
    users!: UserDto[];
}

export class UserDto {
    id!: string;
    first_Name!:string;
    last_Name!:string;
    userName!: string;
    email!: string;
    emailConfirmed!: boolean;
    phoneNumber!: string;
    phoneNumberConfirmed!: boolean;
    lockoutEnabled!: boolean;
    twoFactorEnabled!: boolean;
    accessFailedCount!: number;
    lockoutEnd?:Date;
    createdWhen!: Date;
    userRoles!:PlatformGroupRoleDto[];
    isDemoUser!: boolean;
    isRoleMember!: boolean;
    tenant!:TenantDto[];
    copyUser!:UserDto;
}

export class DemoUserDto {
    id!: string;
    userName!: string;
    companyName!: string;
    email!: string;
    phoneNumber!: string;
    buildingconstruction!: boolean;
    infrastructure!: boolean;
}

export class UserResolved {
    userDto!: UserDto;
    error?:any;    
}

export class LoginInputModel
{
    email!: string;
    password!: string;
}

export class TenantUserPGR {
    userId!: string;
    userName!: string;
    email!: string;
    isRoleMember!: boolean;
    isChanged!: boolean;
    isNew!: boolean;
    tenantId!: string;
    tenantName!: string;
    projId!: string;
    roleId!: string;
    roleName!: string;
    copyUserId!: string;
    inclTGR!: boolean;
    isTenantAdmin!: boolean;
}



